import { forwardRef, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const BaseDialog = ({ open, onClose, hideCloseButton = false, hasTransition = true, title, content, actions, children, otherPaperStyle, ...otherProps }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={!!hasTransition ? Transition : undefined}
      PaperProps={{
        sx: {
          borderRadius: '4px',
          boxShadow: 'none',
          ...otherPaperStyle
        }
      }}
      {...otherProps}
    >
      {!hideCloseButton && <Button onClick={onClose} disableRipple sx={{ position: 'absolute', top: 2, right: 2, minWidth: 36, minHeight: 36, padding: 0, backgroundColor: 'transparent !important', zIndex: 1 }}><CloseIcon sx={{ color: 'rgba(0,0,0,.3)' }} /></Button>}
      {!!title && (
        <DialogTitle sx={{
          pt: 4, pb: 2, position: 'relative',
          fontSize: '1rem', fontWeight: 600, color: '#000', textAlign: 'center'
        }}>
          {title}
        </DialogTitle>)}
      {!!content && (
        <DialogContent sx={{ p: 0 }}>
          {content}
        </DialogContent>
      )}
      {!!children && children}
      {!!actions && (<DialogActions sx={{ pt: 2, pb: 4, justifyContent: 'center' }}>{actions}</DialogActions>)}
    </Dialog>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BaseDialog {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);